import { BlockUI } from 'primereact/blockui';
import Dialog from '@/components/dialog/Dialog';
import DialogHeader from '@/components/dialog/DialogHeader';

import NiceModal, { NiceModalHocProps, useModal } from '@ebay/nice-modal-react';
import { useState } from 'react';
import { RoundButton, RoundedFilledButton, RoundedOutlinedFilledButton } from '../buttons/Buttons';
import { HiOutlineCheck } from 'react-icons/hi';
import { languages } from '@/constants/languages';

type Props = {
	//Id: number;
};

export const SelectLanguageDialogModal = NiceModal.create<Props>((props: Props) => {
	return (
		<SelectLanguageDialog {...props} />
	);
});






const SelectLanguageDialog = (props: Props) => {
	// TODO: change formId this to be in-line with how the
	// LoginForm works once implementation has been started.
	const [formBlocked, setFormBlocked] = useState(false);
	const [selectedIdx, setSelectedIdx] = useState<number | null>(2);
	// const [selectedCountry, setSelectedCountry] = useState<Country | null>({
	// 	name: 'Philippines',
	// 	code: 'PH',
	// });

	var modal = useModal();

	//const isAdd = props.Id == 0;


	return (
		<Dialog
			//className="w-[600px]"
			className="text-body-large font-poppins"
			//style={{ width: '600px' }}
			header={
				<BlockUI blocked={formBlocked}
				// className={styles.formBlock}
				>
					<span className='text-headline-small'>Select Language</span>
					{/* <DialogHeader title="Select Language" /> */}
				</BlockUI>
			}
			visible={true}
			onHide={() => {
				modal.remove();
			}}
		>
			{languages.map((lang, idx) => (
				<>
					<div
						key={idx}
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
							padding: "14px 14px 14px 0",
						}}
						onClick={() => setSelectedIdx(idx)}
					>
						<span>{lang.Name}</span>
						{selectedIdx === idx && (
							<HiOutlineCheck size={24} className="text-tertiary" />
						)}
					</div>
					<hr />
				</>
			))}


			<div className="flex justify-end gap-4 pt-12">
				<RoundedOutlinedFilledButton
					id="language-cancel"
					label="Cancel"
					className="text-lg font-medium font-poppins h-12 bg-transparent text-primary"
					onClick={() => {
						modal.resolve();
						modal.remove();
					}}
				/>
				<RoundedFilledButton
					id="language-done"
					label="Done"
					//disabled={!uploaded}
					className="text-lg font-medium font-poppins h-12 py-3 px-6"
					onClick={() => {
						modal.resolve();
						modal.remove();
					}}
				/>
			</div>

		</Dialog>
	);
};

export default SelectLanguageDialog;
